import styled from "styled-components";
import { MobileWidth } from "../../GlobalStyle";

export const FooterWrapper = styled.div`
  background-color: #161616;
  color: #fff;
  text-align: center;
  padding: 60px 0;
  @media screen and (max-width: ${MobileWidth}) {
    padding: 30px 0;
  }

  a {
    color: #fff;

    &:hover {
      color: #787878;
    }
  }

  img {
    filter: invert(1);
    margin-bottom: 20px;
    width: 120px;
    @media screen and (max-width: ${MobileWidth}) {
      margin-bottom: 10px;
      width: 100px;
    }
  }
`;
